import { render, staticRenderFns } from "./TopList.vue?vue&type=template&id=2aecbcb0&scoped=true"
import script from "./TopList.vue?vue&type=script&lang=js"
export * from "./TopList.vue?vue&type=script&lang=js"
import style0 from "./TopList.vue?vue&type=style&index=0&id=2aecbcb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aecbcb0",
  null
  
)

export default component.exports